<template>
    <main class="section-main" id="section4">
        <BlockPromo />
        <BlockInfo />
    </main>
</template>

<script>
import BlockPromo from '@/components/sections/teenage/promo'
import BlockInfo from '@/components/sections/teenage/info'

export default {
    components: {
        BlockPromo,
        BlockInfo
    }
}
</script>

<style scoped>

</style>
